import React from 'react';
import {
  Select, Input,
} from 'antd';
import {
  isNaN, isInteger,
} from 'lodash';
import TextArea from 'antd/lib/input/TextArea';
import FormModal from '../../../../common/FormModal';
import { duration } from '../../../../common/variables/dropdownConstants';

const { Option } = Select;
const PackagesFormModal = ({ data = {}, ...props }) => {
  return (
    <FormModal
      width={1000}
      data={data}
      {...props}
      formItems={[
        {
          key: 'name',
          label: 'Package Name',
          width: 8,
          rules: [{ required: true, message: "Please input Package's name!" }],
        },
        {
          key: 'category',
          label: 'Category',
          width: 8,
          rules: [{ required: true, message: "Please input Category!" }],
          Component: (
            <Select autoComplete="off" placeholder='Select Category' size='large'>
              {props.homeHealthCareServiceCategories && props.homeHealthCareServiceCategories.map((val) => (
                <Option key={val}>
                  {val}
                </Option>
              ))}

            </Select>
          ),
        },
        {
          key: 'duration',
          label: 'Duration',
          width: 8,
          rules: [{ required: true, message: 'Enter Duration!' }],
          Component: (
            <Select placeholder='Select Duration' size='large'>
              {duration.map((val) => (
                <Option key={val}>
                  {val}
                </Option>
              ))}

            </Select>
          ),
        },
        {
          key: 'mrp',
          label: 'MRP',
          rules: [{ required: true, message: 'Please input MRP!' },
          () => ({
            validator(rule, value) {
              if (isNaN(Number(value))) {
                return Promise.reject('Not a valid Number');
              }
              if (value && Number(value) <= 0) {
                return Promise.reject('MRP cannot be less than 1!');
              }
              if (value && !isInteger(Number(value))) {
                return Promise.reject('MRP has to be a whole number!');
              }
              if (Number(value) > 1000000) {
                return Promise.reject('Cannot be more than 10Lakhs');
              }
              return Promise.resolve();
            },
          }),
          ],
          width: 8,
        },

        {
          key: 'discount',
          label: 'Discount %',
          dependencies: ['mrp'],
          rules: [{ required: true, message: "Please enter Discount!" },
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if ((value && Number(value) !== 0) && !getFieldValue('mrp')) {
                return Promise.reject('MRP not set!');
              }
              if (value && Number(value) < 0) {
                return Promise.reject('Discount cannot be less than 0!');
              }
              if (isNaN(Number(value))) {
                return Promise.reject('Not a valid Number');
              }
              if (Number(value) >= 100) {
                return Promise.reject('Cannot be more than 100');
              }
              return Promise.resolve();
            },
          }),
          ],
          width: 8,
        },
        {
          key: 'price',
          label: 'Price',
          rules: [{ required: false, message: "Please input User's name!" }],
          width: 8,
          Component: (
            <Input size='large' disabled />
          ),
        },
        {
          key: 'assessment_fee',
          label: 'Assessment Fee',
          rules: [{ required: true, message: "Please input Assessment fee!" },
          {
            pattern: new RegExp(/^[0-9\s]*$/),
            message: "Field does not accept Alphabets or Special Characters"
          }],
          width: 8,
        },
        {
          key: 'city',
          label: 'City',
          width: 8,
          rules: [{ required: true, message: 'Please input City!' }],
          Component: (
            <Select placeholder='Select City' size='large'>
              {(props.homeSupportedLocations || []).map((val) => <Option value={val.name} key={val.name}>{val.name}</Option>)}
            </Select>
          ),
        },
        {
          key: 'status',
          label: 'Status',
          width: 8,
          rules: [{ required: true, message: "Please input User's status!" }],
          Component: (
            <Select placeholder='Select Status' size='large'>
              <Option value>Active</Option>
              <Option value={false}>Blocked</Option>
            </Select>
          ),
        },
        {
          key: 'equipment_info',
          label: 'Equipment(s) used for this service',
          rules: [{ required: true, message: 'Please Enter Equipment Information' }],
          Component: <TextArea rows={4} placeholder='Enter Equipments' />,
          width: 8,
        },
        {
          key: 'desc',
          label: 'Description about the service offered',
          Component: <TextArea rows={4} placeholder='Enter Description' />,
          width: 16,
        },
        // {
        //   key: 'category',
        //   label: 'Category',
        //   data: props.category,
        //   rules: [{ required: false, message: "Please input User's name!" }],
        //   hidden: true,

        // },
      ]}
    />
  );
};
export default PackagesFormModal;